import { Controller } from '@hotwired/stimulus';

// 区分ラジオ (給与 / 賞与) の切替コントローラ。
// 区分を切り替えると対応するアップロード画面へ遷移する。問題は、別区分を選んで
// 遷移した後にブラウザの「戻る」で元の画面が bfcache から復元されると、ラジオが
// 別区分を選択した見た目のまま戻ってしまう点 (#2025)。各画面のフォームはその画面の
// 区分で送信するため、見た目と送信区分がずれるとデータ整合性リスクがある。
// pageshow (bfcache 復元を含む) と connect で、その画面本来の区分
// (data-csv-type-default-value: "salary" / "bonus"、既定は salary) へ必ず戻す。
export default class extends Controller {
  static targets = ['salary', 'bonus'];
  static values = { default: { type: String, default: 'salary' } };

  connect() {
    this.resetToDefault();
    this.pageshowHandler = this.handlePageshow.bind(this);
    window.addEventListener('pageshow', this.pageshowHandler);
  }

  disconnect() {
    window.removeEventListener('pageshow', this.pageshowHandler);
  }

  handlePageshow() {
    // bfcache から復元された場合 (event.persisted) でも、念のため常に本来の区分へ戻す。
    this.resetToDefault();
  }

  resetToDefault() {
    const bonusDefault = this.defaultValue === 'bonus';
    if (this.hasSalaryTarget) {
      this.salaryTarget.checked = !bonusDefault;
    }
    if (this.hasBonusTarget) {
      this.bonusTarget.checked = bonusDefault;
    }
  }

  change(event) {
    const isSalary = event.target.value === 'salary';
    const url = isSalary
      ? this.element.dataset.csvTypeSalaryUrlValue
      : this.element.dataset.csvTypeBonusUrlValue;
    window.location.href = url;
  }
}
